import { IdManagerIfc } from '../IdManagerIfc';
import { BitBoardBitSetForNext32 } from './BitBoardBitSetForNext32';
import { BitBoardBitSetForMinimum32 } from './BitBoardBitSetForMinimum32';

export class BitBoardIdManager32 implements IdManagerIfc{
        minIds:BitBoardBitSetForMinimum32;
		nextIds:BitBoardBitSetForNext32;
		
		constructor() 
		{
			this.minIds = new BitBoardBitSetForMinimum32();
			this.nextIds = new BitBoardBitSetForNext32();
		}
		
		public allocate():number {
			let allocated:number = this.minIds.allocate();
			this.nextIds.allocateConcrete(allocated);
			return allocated;
		}
		
		public allocateIds( length:number ):Array<number> {
			var ids:Array<number> = new Array();
			for( let i:number = 0; i < length; i++ ){
				ids[i] = this.allocate();
			}
			return ids;
		}
	
		public allocateConcrete( id:number ):void {
			this.minIds.allocateConcrete(id);
			this.nextIds.allocateConcrete(id);
		}
		
		public free( id:number ):void {
			this.minIds.free(id);
			this.nextIds.free(id);
		}
		
		public freeIds( ids:Array<number> ):void {
			for ( let id of ids ){
				this.free( id );
			}		
		}
		
		public isAllocated( id:number ):Boolean {
			let minAlloc:Boolean = this.minIds.isAllocated(id);
			let nextAlloc:Boolean = this.nextIds.isAllocated(id);
			if( minAlloc != nextAlloc ){
				throw new Error("Min and next alloc not equals, min: " + minAlloc + ", nextAlloc: " + nextAlloc );
			}
			return minAlloc;
		}
		
		public nextSetBit( id:number ):number {
			return this.nextIds.nextSetBit(id);
		}
		
		public reset():void {
			this.minIds.reset();
			this.nextIds.reset();
		}
		
		public size():number {
			let minSize:number = this.minIds.size();
			let nextSize:number = this.nextIds.size();
			if( minSize != nextSize ){
				throw new Error("Min and next size not equal, min: " + minSize + ", next: " + nextSize);
			}
			return minSize;
		}
}